export enum Message {
  SearchContact = "Search contact",
  Success = "Success",
  Error = "Error",
  Warning = "Warning",
  Info = "Info",
  ErrorMessage = "An error occurred. Please try again later.",
  ErrorMessageLocationAccess = "Location access blocked. Please enable to continue",
  ErrorMessageLocationUnavailable = "We couldn't determine your location. Check your connection and try again.",
  ErrorMessageCountryAccess = "Access blocked. Application is not available in your country.",
  ErrorMessageDeviceId = "Error in getting deviceId. Please try again later.",
  ErrorMessageDeviceType = "Error in getting device type. Please try again later.",
  ErrorMessageDeviceIpAddress = "Error in getting device IP address. Please try again later.",
  ErrorMessageDeviceGeoCoordinates = "Error in getting device geo coordinates. Please try again later.",
  ErrorMessageDeviceHashId = "Error in getting device hash id. Please try again later.",
  ErrorMessageDevicermation = "Error in getting device information. Please try again later.",
  ErrorMessageGetToken = "Error in getting token. Please try again later.",
  ErrorMessageLinksDisallowed = "Links are not allowed. Please remove any links and try again.",
  ErrorMessageSession = "Error in starting the session. Please try again later.",
  ErrorMessageTokenDate = "Error in getting token date. Please try again later.",
  ErrorMessageGetKeys = "Error in getting keys. Please try again later.",
  LogoutMessage = "You have been logged out.",
  LogoutSuccess = "You have been logged out successfully.",
  SessionExpiredInactivity = "Session expired. Please log in again.",
  InvalidCredentials = "Invalid username or password.",
  EncryptedTextCopiedToClipboard = "Encrypted text copied to clipboard.",
  DecryptedTextCopiedToClipboard = "Decrypted text copied to clipboard.",
  EncryptedTextPastedFromClipboard = "Encrypted text pasted from clipboard.",
  DecryptedTextPastedFromClipboard = "Decrypted text pasted from clipboard.",
  EncryptedDataCleared = "Encrypted data cleared.",
  DecryptedDataCleared = "Decrypted data cleared.",
  Encryption = "encryption",
  ErrorMessageLoginFailed = "Incorrect email/password",
  ErrorMessageIncorrectLoginCredentials = "Incorrect email or password. Please verify and try again.",
  PinResentSuccess = "Pin resent successfully.",
  Forbidden = "Your Session has been expired",
  NotAuthorized = "Not Authorized",
  ErrorMessageSmartyNotAuthorized = "Address suggestions are unavailable because the Smarty address API denied access. Please enter the address manually.",
  ErrorMessageNoConnection = "It looks like you’re not connected to the internet. Check Wi-Fi or data settings and try again.",
  NoRetailerStoreSelected = "No Retailer Found, Please Check Device Location Settings are Enabled.",
  NoRetailerAvailableMessage = "No Retailer Found, If location services are enabled and you are not seeing your store/retailer, please try updating your geo data. Turn off all data/network connections, enable airplane mode, then restart the device. After restarting, re-enable data and attempt to log back in.",
  DuplicateIMEIError = "Duplicate IMEI was submitted, please retype or rescan the IMEI and reattempt submission.",
  ByodESIMOnlyNotEligible = "Device is eSIM only and is not eligible for eSIM activation.",
  ErrorMessageShippingAddressUspsRequired = "Your shipping address must be a USPS validated address and cannot be a PO BOX.",
  ErrorMessageBillingAddressMatchesService = "The billing address cannot match the service address.",
  CreditCheckFailedErrorMessageTitle = "Credit Check Failed",
  CreditCheckPageTitle = "Credit Check",
  CreditCheckEnterButton = "Enter Credit Information",
  CreditInformationCollectedSuffix = "Information Collected",
  IdentityVerificationFailed = "Unable to complete identity verification. Please try again.",
  IdentityVerificationSaveFailed = "Unable to save identity verification. Please try again.",
  IdentityVerificationNextStepUnavailable = "Unable to determine the next step after identity verification.",
  WirelessIdAuthenticationDestinationRequired = "Please fix the errors below before proceeding.",
  WirelessIdAuthenticationInvalidPhone = "Please enter a valid phone number",
  WirelessIdAuthenticationInvalidEmail = "Please enter a valid email address",
  WirelessIdAuthenticationIncompleteTitle = "Wireless ID Authentication Incomplete",
  WirelessIdAuthenticationIncompleteDetail = "Please wait for the Customer to complete the authentication process.",
  WirelessIdAuthenticationCompleted = "Wireless ID Authentication Completed!",
  WirelessIdAuthenticationInfoTitle = "Security check required",
  WirelessIdAuthenticationInfoDetail = "Please complete ID authentication below to continue. This helps us keep your account and order secure.",
  WirelessIdAuthenticationSendLink = "SEND ID AUTHENTICATION LINK",
  WirelessIdAuthenticationResendLink = "Resend link",
  WirelessIdAuthenticationCheckStatus = "CHECK AUTHENTICATION STATUS",
  WirelessIdAuthenticationScanHeader = "If the customer cannot complete it themselves",
  WirelessIdAuthenticationScanInstruction = "Have the customer's physical ID ready, and click to scan below",
  WirelessIdAuthenticationScanButton = "SCAN CUSTOMER ID",
  WirelessIdAuthenticationScanPopupBlocked = "Please allow pop-ups for SARA Plus to scan the customer's ID.",
  WirelessIdAuthenticationManualOverPhone = "Use manual authentication over the phone",
  VoiceFlowInternetRequiredErrorMessage = "Please select an Internet plan before choosing a voice product. Voice services require an active Internet plan to work.",
  LaunchInContextProcessErrorMessage = "Unable to process launch in context.",
  LaunchInContextConflictProcessErrorMessage = "Launch is already used. Please contact support for assistance.",
  LaunchInContextInternetUnavailableMessage = "The launched internet plan is not available at this service address. Please verify the service address.",
  DirectTvInstallationHeader = "Schedule DIRECTV Installation",
  DirectTvInstallationScheduledLabel = "DIRECTV Installation is scheduled for:",
  DirectTvDisclaimerHeader = "DIRECTV Disclaimer",
  OfferInformationHeader = "Offer Information",
  WarningMessageUnableToRefreshWirelessPricing = "Unable to refresh wireless pricing. You may continue with the order.",
  WarningMessageUnableToRefreshInternetOffers = "Unable to refresh internet offers. You may continue with the order.",
  WarningTitleQuotedDeviceUnavailable = "Quoted device not available",
  WarningMessageQuotedDeviceUnavailable = "Please select a device for each affected line. Not available: ",
  WirelessConfiguredLinesNotInOrder = "One or more configured lines would be left out of this order. Please refresh the page and review every line before continuing.",
  AccountReviewWebToolTitle = "This account requires AT&T review.",
  AccountReviewOpenSalesTool = "OPEN SALES TOOL",
  SerialNumbersValidated = "Serial numbers validated successfully.",
  SerialNumbersNotValidatedByDirecTv = "One or more serial numbers could not be validated with DIRECTV. Please check the serial numbers and try again.",
  AccountReviewPhoneReviewLink = "I want to do my review over the phone",
  AccountReviewPhoneReviewNotice = "Using the SCI tool will result in faster resolution but you can call and do your review over the phone if needed",
  AccountReviewUseSciTool = "I would like to use the SCI tool",
  AccountReviewCallReviewIn = "I want to call my review in",
  SoboSalesOptionsHeading = "Select applicable sales options below",
  SoboAccountLabel = "Account",
  SoboAccountPlaceholder = "Select an account",
  SoboAccountLockedPlaceholder = "Accepted Dealer Code",
  SoboDealerCodeLabel = "Dealer Code",
  SoboDealerCodeSearchPlaceholder = "Start typing code",
  SoboDealerCodePlaceholder = "Enter Code",
  SoboRepIdLabel = "Rep ID",
  SoboRepIdPlaceholder = "Enter Rep ID",
  SoboDnisLabel = "DNIS",
  SoboDnisPlaceholder = "Enter DNIS",
  SoboValidateButton = "VALIDATE",
  SoboDealerCodeRequired = "Dealer Code is required.",
  SoboDealerCodeNotValidated = "Validate the Dealer Code and accept the dealer information to continue.",
  SoboChannelLabel = "Channel:",
  SoboDealerCodeTableLabel = "Dealer Code:",
  SoboLocationLabel = "Location:",
  SoboValidationHeader = "Channel & Dealer Code Validation",
  SoboDetailsHeader = "Channel & Dealer Code Details",
  SoboContinueQuestion = "Would you like to continue with the account information above?",
  SoboErrorHeader = "Dealer Code/Rep ID - Error",
  SoboDealerDetailsLoadError = "Unable to load dealer details.",
  SoboTryAgain = "Please try again",
  SoboYesButton = "YES",
  SoboNoButton = "NO",
  SoboOkButton = "OK",
  FdeOrderOptionsNote = "After completing the requirements above use the Submit button below to refresh package details with AT&T.",
}

/** Order stepper text (story 10869). */
export enum StepperMessage {
  Programming = "Programming",
  Hardware = "Hardware",
  Configuration = "Configuration",
  CreditCheck = "Credit Check",
  Offers = "Offers",
  Options = "Options",
  Summary = "Summary",
  OrderProgress = "Order progress",
  Complete = "Complete",
  CompleteSuffix = "complete",
  InProgress = "In progress",
  NotStarted = "Not started",
  Of = "of",
  Done = "done",
  More = "more",
  ReadyToFinalize = "Ready to finalize",
  Ready = "Ready",
  NavigationLabel = "Order steps",
}

export const serviceDownMessages: MessageModel[] = [
  {
    severity: 'warn',
    detail: 'Provider services down. Only Lead Data will be collected. For live updates and help, click to scan the QR code below.',
  }
]

export const wirelessSetupErrorSelectionMessages: MessageModel[] = [
  {
    severity: 'warn',
    detail: 'Please make a selection before proceeding',
  }
]

export const expressSchedulingMessages: MessageModel[] = [
  {
    severity: 'success',
    detail: 'The earliest installation times have been pre-selected below. To continue with these times, tap the Submit button.',
  }
]

export const fdeIncompleteMessage: MessageModel[] = [
  {
    severity: 'error',
    detail: 'Wireless ID Authentication Incomplete. Please wait for the Customer to complete the authentication process.',
  }
]

export const fdeCancelledMessage: MessageModel[] = [
  {
    severity: 'error',
    detail: 'AT&T is unable to proceed with this order. Do not call for review.',
  }
]

export const fdeCompleteMessage: MessageModel[] = [
  {
    severity: 'success',
    detail: 'Wireless ID Authentication Completed!',
  }
]

export const channelsErrorMessage: MessageModel[] = [
  {
    severity: 'error',
    Title: 'Please check all mandatory fields before proceeding.',
    detail: 'All required fields must be completed before continuing. These fields are highlighted for your attention.'
  }
]

export const landlordErrorMessage: MessageModel[] = [
  {
    severity: 'error',
    Title: 'Landlord Permission Required',
    detail: 'Please make a selection before proceeding.'
  }
]

export interface MessageModel {
  severity: 'success' | 'error' | 'warn' | 'info';
  Title?: string;
  detail: string;
}
